module.exports = __webpack_public_path__ + "img/comment-alt.d94a55b1.svg";